import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-material.css";
import { useCallback, forwardRef } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

import Box from "@mui/material/Box";

ModuleRegistry.registerModules([AllCommunityModule]);

const ERPGrid = forwardRef<AgGridReact, React.PropsWithChildren<any>>(
  (
    { gridHeight, gridWidth, exportToExcel, heading, processBtn, ...gridProps },
    ref
  ) => {
    const onBtnExport = useCallback(() => {
      if (ref && "current" in ref && ref.current) {
        ref.current.api.exportDataAsCsv();
      }
    }, []);

    return (
      <Box
        className="ag-theme-material"
        sx={{
          width: gridWidth || "100%",
          height: gridHeight || "80vh",
          "--ag-background-color": (theme) => theme.palette.background.paper,
          "--ag-foreground-color": (theme) => theme.palette.text.primary,
          "--ag-header-background-color": (theme) =>
            theme.palette.action.hover,
          "--ag-header-foreground-color": (theme) => theme.palette.text.primary,
          "--ag-border-color": (theme) => theme.palette.divider,
          "--ag-row-border-color": (theme) => theme.palette.divider,
          "--ag-odd-row-background-color": (theme) =>
            theme.palette.action.hover,
          "--ag-row-hover-color": (theme) => theme.palette.action.hover,
          "--ag-selected-row-background-color": (theme) =>
            alpha(theme.palette.primary.main, 0.16),
          "& .ag-header-row": { bgcolor: "action.hover" },
          "& .ag-row-odd": { bgcolor: "action.hover" },
          "& .ag-row-hover": {
            cursor: "pointer",
          },
          "& .ag-cell": { paddingY: "4px" },
          "& .ag-row-focus": {
            backgroundColor: (theme) =>
              alpha(theme.palette.primary.main, 0.16),
            fontWeight: "bold",
          },
        }}
      >
        <Box
          display={"flex"}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          {processBtn && (
            <Button
              onClick={processBtn.onClick}
              color={processBtn.color}
              sx={{ mb: 1, mr: 1, width: "160px" }}
              variant="outlined"
            >
              {processBtn.label}
            </Button>
          )}
          {exportToExcel && (
            <Button
              variant="outlined"
              onClick={onBtnExport}
              sx={{ mb: 1, width: "160px" }}
            >
              Export CSV
            </Button>
          )}

          {heading && (
            <Typography
              sx={{ flex: 1, fontWeight: "bold" }}
              textAlign={"center"}
            >
              {heading}
            </Typography>
          )}
        </Box>
        <AgGridReact ref={ref} {...gridProps}   />
      </Box>
    );
  }
);

export default ERPGrid;
